export const UAE_EMIRATES = [
  { value: 'AE-AZ', label: 'Abu Dhabi' },
  { value: 'AE-AJ', label: 'Ajman' },
  { value: 'AE-DU', label: 'Dubai' },
  { value: 'AE-FU', label: 'Fujairah' },
  { value: 'AE-RK', label: 'Ras Al Khaimah' },
  { value: 'AE-SH', label: 'Sharjah' },
  { value: 'AE-UQ', label: 'Umm Al Quwain' },
];

export const UAE_PAYMENT_MEANS = [
  { value: '10', label: '10 — Cash' },
  { value: '20', label: '20 — Cheque' },
  { value: '30', label: '30 — Credit transfer' },
  { value: '48', label: '48 — Bank card' },
  { value: 'ZZZ', label: 'ZZZ — Mutually defined' },
];

export const LEGAL_REGISTRATION_TYPES = [
  { value: 'TL', label: 'Trade license' },
  { value: 'CR', label: 'Commercial registration' },
  { value: 'OTHER', label: 'Other' },
];
